import { Flex, MDIIcon, Modal } from '@solinkcorp/solink-components';
import Print from '@solinkcorp/solink-components/svg/print.svg?react';
import { withAspen } from 'components/aspen/withAspen';
import React from 'react';
import EventDetails from '../EventsPage/EventDetails';
import './PrintPanel.sass';
import { PrintPanelAspen } from './PrintPanelAspen';
import Thumbnails from './Thumbnails';
import { usePrintPanelDialog, type PrintPanelProps } from './usePrintPanelDialog';

export const PrintPanel: React.FC<PrintPanelProps> = ({ printPanelOpen, event, closePanel }) => {
  const {
    locale,
    location,
    modalCloseAction,
    handlePrintClick,
    subtitle,
    title,
    description,
    date,
    timeDisplay,
    timezone,
  } = usePrintPanelDialog({ event, closePanel });

  const actions = [
    { text: locale.general.close, onClick: modalCloseAction, isPrimary: false },
    {
      text: locale.print.printButton,
      onClick: handlePrintClick,
      icon: <MDIIcon icon={Print} size={12} style={{ marginRight: '6px' }} />,
    },
  ];

  const subTitle = (
    <div>
      <div className="subtitle-content">{subtitle}</div>
      <Flex>
        <div className="subtitle-left-col">{date}</div>
        <div>{timeDisplay}</div>
      </Flex>
    </div>
  );

  return (
    <Modal
      className="print-modal"
      isOpen={printPanelOpen}
      onClose={modalCloseAction}
      title={title}
      subTitle={subTitle}
      actions={actions}
      modalWrapperClassName="print-modal-wrapper"
    >
      <div className="modal-content">
        {/* Event from virtual locations won't have the location object returned from the API. Virtual locations are data only locations that don't have cameras */}
        {location && <Thumbnails eventCameras={event.cameras} location={location} />}
        <div className="text-wrapper">
          {title && (
            <Flex justifyContent="center">
              <h3 className="title">{title}</h3>
            </Flex>
          )}
          {description && (
            <Flex justifyContent="center">
              <div className="description">{description}</div>
            </Flex>
          )}
          <Flex justifyContent="center">
            <pre className="details">
              <EventDetails event={event} timezone={timezone} />
            </pre>
          </Flex>
        </div>
      </div>
    </Modal>
  );
};

export default withAspen(PrintPanel, PrintPanelAspen);
